import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneButton',
  props: {
    phone: {},
    height: {},
    iconMobile: { type: Boolean, default: false },
    isIcon: { type: Boolean, default: false },
    phoneModal: { type: Boolean },
    btnType: { default: 'greenBorder' }
  },
  setup(__props: any) {

const props = __props;

const showPhone = ref(false);
const showPhoneModal = ref(false);

const changeShowPhone = () => {
  showPhone.value = !showPhone.value;
  if (showPhone.value) {
    useAppStore().sendStatistic(15);
  }
};
const openPhoneModal = () => {
  showPhoneModal.value = true;
  useAppStore().sendStatistic(15);
};

const preparedPhone = computed((): string => {
  if (props.phone) {
    return props.phone.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '+7 ($1) $2-$3-$4');
  }

  return '-';
});

const btnPhoneText = computed((): string => {
  if (showPhone.value && props.phone) {
    return preparedPhone.value;
  } else {
    return 'Телефон';
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isIcon)
      ? (_openBlock(), _createBlock(_component_base_button, {
          key: 0,
          class: _normalizeClass({ showPhone: showPhone.value, 'none-Mobile': _ctx.iconMobile, phoneButton: !_ctx.phoneModal }),
          disabled: _ctx.phone === '-' || !_ctx.phone,
          height: _ctx.height,
          text: btnPhoneText.value,
          "all-block-width": "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.phoneModal ? openPhoneModal() : changeShowPhone()))
        }, null, 8, ["class", "disabled", "height", "text"]))
      : _createCommentVNode("", true),
    (_ctx.iconMobile || _ctx.isIcon)
      ? (_openBlock(), _createBlock(_component_base_button, {
          key: 1,
          class: _normalizeClass({ 'only-mobile': _ctx.iconMobile }),
          disabled: _ctx.phone === '-' || !_ctx.phone,
          "style-type": _ctx.btnType,
          icon: "",
          "without-active": "",
          onClick: openPhoneModal
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_base_icon, {
              color: "#009D3E",
              "font-size": "20",
              name: "call"
            })
          ]),
          _: 1
        }, 8, ["class", "disabled", "style-type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_base_modal, {
      "show-modal": showPhoneModal.value,
      "hide-title": "",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showPhoneModal.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(preparedPhone.value), 1)
      ]),
      btn: _withCtx(() => [
        _createVNode(_component_base_button, {
          height: "40",
          text: "Ок",
          width: "100",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showPhoneModal.value = false))
        })
      ]),
      _: 1
    }, 8, ["show-modal"])
  ], 64))
}
}

})